import { render, staticRenderFns } from "./GeoLegendInfo.vue?vue&type=template&id=492f7787"
import script from "./GeoLegendInfo.vue?vue&type=script&lang=js"
export * from "./GeoLegendInfo.vue?vue&type=script&lang=js"
import style0 from "./GeoLegendInfo.vue?vue&type=style&index=0&id=492f7787&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports